"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _PromotionBannerContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/banners/PromotionBannerContainer"));

var _PartnerProgramBanner = _interopRequireDefault(require("pricing-pages-unified-ui/components/banners/PartnerProgramBanner"));

var _ActiveQuoteBanner = _interopRequireDefault(require("./ActiveQuoteBanner"));

var _EnvironmentWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/EnvironmentWrapper"));

var _MarketingBasicPromoBanner = _interopRequireDefault(require("./MarketingBasicPromoBanner"));

var _SalesProSeatPriceChangeBanner = _interopRequireDefault(require("./SalesProSeatPriceChangeBanner"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("pricing-pages-unified-ui/utils/responsiveBreakpoints"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-bottom: 16px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: grid;\n  grid-auto-rows: auto;\n  grid-row-gap: 16px;\n\n  &:not(:empty) {\n    margin-bottom: 16px;\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PromotionGrid = _styledComponents.default.div.withConfig({
  displayName: "BannerSection__PromotionGrid",
  componentId: "sc-1tmok6a-0"
})(_templateObject(), _responsiveBreakpoints.default.tabletPortrait(_templateObject2()));

var BannerSection = function BannerSection(_ref) {
  var hub = _ref.hub,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["hub"]);
  return _react.default.createElement(PromotionGrid, rest, _react.default.createElement(_PromotionBannerContainer.default, {
    hub: hub
  }), _react.default.createElement(_EnvironmentWrapper.default, {
    authedNode: _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_PartnerProgramBanner.default, null), _react.default.createElement(_ActiveQuoteBanner.default, {
      hub: hub
    }), _react.default.createElement(_MarketingBasicPromoBanner.default, {
      hub: hub
    }), _react.default.createElement(_SalesProSeatPriceChangeBanner.default, null))
  }));
};

BannerSection.propTypes = {
  hub: _propTypes.default.string.isRequired
};
var _default = BannerSection;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/BannerSection.js
// module id = 255
// module chunks = 5 6